export const errors = {
  'error.store.unavailable': 'Online ordering is currently unavailable',
};
